import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap-5';
import { setPrimaryRole } from '../../actions';
import { put } from 'helpers/api';
import {
  PRIMARY_ROLE_INVESTOR_OWNER,
  PRIMARY_ROLE_COMMERCIAL_BROKER,
  PRIMARY_ROLE_RESIDENTIAL_BROKER,
  PRIMARY_ROLE_OTHER,
  isValidPrimaryRole,
  labelForPrimaryRole
} from '../../actions/ui';
import { fetchTranslation } from '../../../../helpers/i18n';

// TODO: probably good to collapse (or even hide) the sidebar so user isn't distracted with other flows
// TODO: save their choice (in the session?) so reloading doesn't re-prompt
export function AskUserType({ accountPath, hideLoginPrompt, nextStep, onNext, primaryRole, setPrimaryRole }) {
  useEffect(() => {
    if (isValidPrimaryRole(primaryRole)) {
      // In rare cases, like in the NIM workflow, there could be a user signed in at this point.
      // This will attempt to save the changes immediately. If no user is signed in, this is a no-op
      put(accountPath, { loginCredential: { profileAttributes: { primaryRole } } })
        .catch(() => {}); // Silently fail if no one is logged in

      onNext({ overrideStep: nextStep });
    }
  }, [primaryRole]);

  return (
    <div className="py-2">
      <div className="text-center">
        <h5 className="mb-4">{fetchTranslation('are_you_a')}</h5>
      </div>
      <div className="d-flex flex-column align-items-stretch gap-3 m-auto" style={{ maxWidth: '300px' }}>
        <Button variant="primary" onClick={() => setPrimaryRole(PRIMARY_ROLE_INVESTOR_OWNER)}>
          {labelForPrimaryRole(PRIMARY_ROLE_INVESTOR_OWNER)}
        </Button>
        <Button variant="primary" onClick={() => setPrimaryRole(PRIMARY_ROLE_COMMERCIAL_BROKER)}>
          {labelForPrimaryRole(PRIMARY_ROLE_COMMERCIAL_BROKER)}
        </Button>
        <Button variant="primary" onClick={() => setPrimaryRole(PRIMARY_ROLE_RESIDENTIAL_BROKER)}>
          {labelForPrimaryRole(PRIMARY_ROLE_RESIDENTIAL_BROKER)}
        </Button>
        <Button variant="primary" onClick={() => setPrimaryRole(PRIMARY_ROLE_OTHER)}>
          {labelForPrimaryRole(PRIMARY_ROLE_OTHER)}
        </Button>
      </div>
      {!hideLoginPrompt && (
        <div className="d-flex justify-content-center mt-6">
          <button className="btn btn-link js-login">
            {fetchTranslation('do_you_have_existing_account')}
          </button>
        </div>
      )}
    </div>
  );
}

AskUserType.propTypes = {
  accountPath: PropTypes.string,
  hideLoginPrompt: PropTypes.bool,
  nextStep: PropTypes.string,
  primaryRole: PropTypes.string,
  setPrimaryRole: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired
};

const mapStateToProps = ({ ui }) => ({ primaryRole: ui.primaryRole });
const mapDispatchToProps = { setPrimaryRole };

export default connect(mapStateToProps, mapDispatchToProps)(AskUserType);
